export const getDataLogin = () => {
  const storedData = localStorage.getItem("data-login");

  if (storedData) {
    try {
      const data = JSON.parse(storedData);
      return data.data.data || "";
    } catch (error) {
      console.error("Error parsing JSON from localStorage:", error);
      return "";
    }
  }

  return null;
};
